import { useState } from 'react';
import { ChevronDown, ChevronRight, Plus, Trash2 } from 'lucide-react';
import { IconButton } from './ui.jsx';

export function Inventory({ title, items, draft, collapsed, onToggle, onDraft, onAdd, onQuantityChange, onToggleLow, onRemove }) {
  const [search, setSearch] = useState('');
  const [showLowOnly, setShowLowOnly] = useState(false);
  const lowCount = items.filter((item) => item.low).length;
  const filtered = items.filter((item) => {
    if (showLowOnly && !item.low) return false;
    if (search && !item.name.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });
  return (
    <section className={collapsed ? 'panel collapsible-panel is-collapsed' : 'panel collapsible-panel'}>
      <button className="section-heading collapse-heading" onClick={onToggle} type="button" aria-expanded={!collapsed}>
        <h3>{title} <span className="item-count">{items.length}</span></h3>
        {lowCount > 0 && <span className="status-chip">{lowCount} low</span>}
        {collapsed ? <ChevronRight size={18} /> : <ChevronDown size={18} />}
      </button>
      {!collapsed && (
        <div className="scroll-panel">
          <div className="inventory-filter-bar">
            <input
              className="inventory-search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={`Search ${items.length} items…`}
              aria-label={`Search ${title}`}
            />
            <button
              className={showLowOnly ? 'low-filter-toggle active' : 'low-filter-toggle'}
              onClick={() => setShowLowOnly((v) => !v)}
              type="button"
            >
              {lowCount} low
            </button>
          </div>
          <div className="mini-composer">
            <input
              value={draft}
              onChange={(event) => onDraft(event.target.value)}
              onKeyDown={(event) => event.key === 'Enter' && onAdd()}
              placeholder={`Add to ${title.toLowerCase()}…`}
            />
            <button className="icon-button add" onClick={onAdd} type="button" aria-label={`Add ${title} item`}>
              <Plus size={16} />
            </button>
          </div>
          <div className="inventory-stack">
            {filtered.length === 0 && (
              <p className="empty-drop-text">{search || showLowOnly ? 'No items match.' : 'No items yet.'}</p>
            )}
            {filtered.map((item) => (
              <div className="inventory-row" key={item.id}>
                <span>{item.name}</span>
                <input
                  className="quantity-input"
                  value={item.quantity}
                  onChange={(event) => onQuantityChange(item.id, event.target.value)}
                  aria-label={`${item.name} quantity`}
                />
                <button
                  className={item.low ? 'low-chip on' : 'low-chip'}
                  onClick={() => onToggleLow(item.id)}
                  type="button"
                  aria-label={item.low ? 'Mark in stock' : 'Mark as low'}
                  title={item.low ? 'Mark in stock' : 'Mark as low'}
                >
                  {item.low ? 'Low' : '·'}
                </button>
                <IconButton label="Remove" icon={Trash2} onClick={() => onRemove(item.id)} />
              </div>
            ))}
            {(search || showLowOnly) && filtered.length < items.length && (
              <p className="filter-result-note">{filtered.length} of {items.length} shown</p>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
